import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { ProductivityService } from 'src/app/services/productivity-service';
import { BaseApi } from 'src/backend/api/base-api';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-paramater-dialog',
  templateUrl: './paramater-dialog.component.html',
  styleUrls: ['./paramater-dialog.component.scss'],
})
export class ParamaterDialogComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  isAccess = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_ACCESS;
  isWrite = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_CREATE;
  isUpdate = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_UPDATE;
  isDelete = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_DELETE;

  parameterRowData: FormGroup;
  parameterAddModel!: MatTableDataSource<any>;
  addtabledata: any[] = [];
  counter = 1;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  parameterTempData: any[] = [];
  parameters: any[] = [];
  formMode!: boolean;
  unit: string = '';
  plantSession: any;
  groupSession: any;
  userSession: any;
  filteredParameters: any[] = [];
  itemColumns: string[] = [
    'itemActions',
    'parameter',
    'actual',
    'lifeSpan',
    'target',
    'rules',
  ];

  constructor(
    public dialogRef: MatDialogRef<ParamaterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translater: TranslaterService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private productivityservice: ProductivityService,
    private baseApi: BaseApi
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    this.initializeParameterForm();
  }

  ngOnInit() {
    this.getData();
    this.addTable();
    this.getLangWords();
    this.formMode = true;
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.getParameterTarget();
  }

  getData(): void {
    const checkDataInterval = setInterval(() => {
      if (this.data && this.data.unit) {
        clearInterval(checkDataInterval);
        this.unit = this.data.unit;
        this.getParameters();
      }
    }, 100);
  }

  getParameters(): void {
    const key = { PUID: this.unit };
    this.spinner.show();
    this.productivityservice.getVariableGroupParametrs(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.parameters = data.Table;
        this.filteredParameters = data.Table;;
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message);
      }
    );
  }

  initializeParameterForm(): void {
    this.parameterRowData = this.fb.group({
      parameter: [''],
      actual: [''],
      lifeSpan: [''],
      target: [''],
      rules: this.fb.group({
        condition: [''],
        number: [0],
        unit: [''],
      }),
    });
  }
  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        // this.prTable.refreshHeader();
      }
    });
  }
  updateValue(event: any, data: any, field: string, index: number): void {
    const value = parseFloat(event.target.value) || 0;
    if (this.addtabledata) {
      this.addtabledata[index][field] = Number.isInteger(value) ? value : value.toFixed(2);
      if (field === 'actual' || field === 'lifeSpan') {
        this.addtabledata[index].target = this.calculateTarget(
          this.addtabledata[index].actual,
          this.addtabledata[index].lifeSpan
        );
      }
      this.parameterAddModel = new MatTableDataSource<any>(this.addtabledata);
      this.getPaginator();
    }
  }

  updateRule(event: any, data: any, ruleField: string, index: number): void {
    if (ruleField === 'number') {
      this.addtabledata[index].rules[ruleField] = event.target.value ? parseFloat(event.target.value) : null;
    } else {
      this.addtabledata[index].rules[ruleField] = event.value || null;
    }
    this.parameterAddModel = new MatTableDataSource<any>(this.addtabledata);
    this.getPaginator();
  }

  calculateTarget(actual: number, lifeSpan: number): number {
    return actual || lifeSpan ? actual + lifeSpan : 0; // Example calculation, adjust as needed
  }

  columnItemEvent(event: any, data: any, i: number): void {
    this.addtabledata[i].parameter = event.value;
    this.parameterAddModel = new MatTableDataSource<any>(this.addtabledata);
    this.getPaginator();
  }

  getPaginator(): void {
    setTimeout(() => {
      this.parameterAddModel.paginator = this.paginator;
      this.parameterAddModel.sort = this.sort;
    }, 1000);
  }

  addTable(): void {
    const validationError = this.validateTableData();
    if (validationError) {
      this.toaster.error(validationError);
      return;
    }

    const row = {
      id: 0,
      parameter: this.parameterRowData.value.parameter,
      actual: this.parameterRowData.value.actual || 0,
      lifeSpan: this.parameterRowData.value.lifeSpan || 0,
      target: this.calculateTarget(
        this.parameterRowData.value.actual || 0,
        this.parameterRowData.value.lifeSpan || 0
      ),
      rules: {
        condition: this.parameterRowData.value.rules.condition || '',
        number: this.parameterRowData.value.rules.number || 0,
        unit: this.parameterRowData.value.rules.unit || '',
      },
      taskId: 0,
    };

    this.addtabledata.push(row);
    this.parameterAddModel = new MatTableDataSource<any>(this.addtabledata);
    this.getPaginator();
    this.counter++;
  }

  deleteRow(element: any, index: number): void {
    if (element.id === 0) {
      this.spinner.hide();
      this.addtabledata.splice(index, 1);
      this.parameterAddModel = new MatTableDataSource<any>(this.addtabledata);
      this.getPaginator();
      this.toaster.success('Row Deleted Successfully');
    }
    else {

      this.productivityservice.deleteParameterTarget(element.Id, this.userSession.userCode).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.status) {
            this.addtabledata = this.addtabledata.filter(
              (item) => item.id !== element.id
            );
            this.parameterAddModel = new MatTableDataSource<any>(this.addtabledata);
            this.getPaginator();
            this.toaster.success('Row Deleted Successfully');
            this.dialogRef.close(true);
          } else {
            this.toaster.error(
              res.message || 'Failed to Delete Parameter Targets'
            );
          }
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(error.message || 'An Error Occurred');
        }
      );
    }

  }

  createParameterTarget(): void {
    this.spinner.show();
    const validationError = this.validateTableData();
    if (validationError) {
      this.spinner.hide();
      this.toaster.error(validationError);
      return;
    }

    if (this.addtabledata.length === 0) {
      this.spinner.hide();
      this.toaster.error('Fill Data Correctly');
      return;
    }

    const payload = this.addtabledata.map((item) => {
      const base = {
        id: item.id || 0,
        taskId: this.data.taskId,
        parameterId: item.parameter,
        actual: parseFloat(item.actual) || 0,
        lifeSpan: parseFloat(item.lifeSpan) || 0,
        target: parseFloat(item.target) || 0,
        ruleCondition: item.rules?.condition || null,
        ruleNumber: parseFloat(item.rules?.number) || 0,
        ruleUnit: item.rules?.unit || null,
        plantCode: this.plantSession.plantCode,
        groupCode: this.groupSession.groupCode,
      };

      // Add createdBy or updatedBy based on ID
      if (item.id > 0) {
        return { ...base, updatedBy: this.userSession.userCode };
      } else {
        return { ...base, createdBy: this.userSession.userCode };
      }
    });


    this.productivityservice.createParameterTarget(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success('Parameter Targets Created Successfully');
          this.dialogRef.close(true);
        } else {
          this.toaster.error(
            res.message || 'Failed to Create Parameter Targets'
          );
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.message || 'An Error Occurred');
      }
    );
  }

  validateTableData(): string | null {
    if (this.addtabledata.length > 0) {
      const invalidRow = this.addtabledata.find(
        (x) => !x.parameter || !x.target || !x.rules.condition || !x.rules.number || !x.rules.unit
      );
      if (invalidRow) {
        return 'Please fill Parameter and Target for all rows';
      }
    }
    return null;
  }

  getParameterTarget(): void {
    this.productivityservice.getParameterTarget(this.data.taskId).subscribe((response: any) => {

      if (response?.status && response?.data.length > 0) {
        this.parameterAddModel = response.data.map((item: any) => ({
          Id: item.Id,
          parameter: item.ParameterId,
          actual: item.Actual,
          lifeSpan: item.LifeSpan,
          target: item.Target,
          rules: {
            condition: item.RuleCondition,
            number: item.RuleNumber,
            unit: item.RuleUnit
          },
          id: item.Id,
          taskId: item.TaskId,
          // Add other fields if needed
        }));
        this.addtabledata = response.data.map((item: any) => ({
          Id: item.Id,
          parameter: item.ParameterId,
          actual: item.Actual,
          lifeSpan: item.LifeSpan,
          target: item.Target,
          rules: {
            condition: item.RuleCondition,
            number: item.RuleNumber,
            unit: item.RuleUnit
          },
          id: item.Id,
          taskId: item.TaskId,
          // Add other fields if needed
        }));
      }
    });
  }

}
